
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  watch: {
    mobileCurrentMonthSummary(newVal, oldVal) {
      (this as any).handleMobileCurrentMonthSummary(newVal);
    }
  },
  components: {
    Icon: () => import("@/views/admin/dashboard/icons/Index.vue")
  },
  computed: {},
  filters: {}
})
export default class MonthSummary extends Vue {
  @Prop(Object) readonly monthSummary: any;
  @Prop(Function) readonly handleMobileCurrentMonthSummary;
  mobileCurrentMonthSummary: string = "solicitud";
  async mounted() {}
}
